import { api, API_HEADER_DEFAULT, apiImpressao } from "./../../config/api";
import { toFormData, toQueryString } from "../../helpers/form";
import axios from "axios";

const basePath = "relatorio";

/**
 * Create frequency
 *
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
export const frequency = (options) => {
  return api.post(`${basePath}/frequencia`, options);
};

/**
 * Create totals
 *
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
export const totals = (options) => {
  return api.post(`${basePath}/totais`, toFormData(options));
};

/**
 * Create mirror point
 *
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
export const mirrorPoint = (options) => {
  return api.post(`${basePath}/espelhoponto`, toFormData(options));
};

/**
 * Create tax files
 *
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
export const taxFiles = (options) => {
  return api.post(`${basePath}/arquivosfiscais`, toFormData(options), {
    timeout: 7200000, // 2 hours
  });
};

/**
 * Create employee
 *
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
export const employee = (options) => {
  return api.post(`${basePath}/funcionario`, options, { responseType: "blob" });
};

/**
 * Create bank statement hours
 *
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
export const bankStatementHours = (options) => {
  return api.post(`${basePath}/extratobancohoras`, toFormData(options));
};

/**
 * Create occurrences
 *
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
export const occurrences = (options) => {
  return api.post(`${basePath}/occurrences`, toFormData(options));
};

/**
 * Create bank statement hours
 *
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
export const absenteeism = (options) => {
  return api.post(`${basePath}/absenteeism`, toFormData(options));
};

/**
 * Create bank statement hours
 *
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
export const absenteeism2 = (options) => {
  return api.post(`${basePath}/absenteeism2`, toFormData(options));
};

/**
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
export const removals = (options) => {
  return api.post(`${basePath}/removals`, toFormData(options));
};

/**
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
export const geolocation = (options) => {
  return api.post(`${basePath}/geolocations`, toFormData(options));
};

/**
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
export const receipts = (options) => {
  return api.post(`${basePath}/receipts`, toFormData(options));
};

/**
 * Dowload receipt
 *
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
export const dowloadReceipt = (options) => {
    const baseURL = api.defaults.baseURL.replace('/v1/admin', '');
    return api.get(`${baseURL}impressao/cartao-registro/${options.ponto_registro_id}`);
};

/**
 * Dowload multiplos comprovantes
 *
 *
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
export const dowloadReceiptMultiple = (options) => {
  return api.get(`${basePath}/receipts/printMultiple${toQueryString(options)}`, {
    responseType: 'blob',
  });
}
